/* eslint-env browser */
'use strict';
import $ from 'jquery';
import PostcardPreview from 'modules/postcard-preview';
import Utility from 'modules/utility';
import _ from 'underscore';

/**
 * The form controller for the postcard app.
 */
class PostcardForm {
  /**
   * Constructor function
   * @constructor
   * @param {HTMLElement} el - component element
   */
  constructor(el) {
    /** @prop {HTMLElement} Component form element. */
    this.el = el;

    /** @prop {jQuery} Component element in a jQuery wrapper. */
    this.$el = $(el);
  }

  /**
   * Initialization function. Pre-fills form and binds event handlers.
   * @method
   * @return {this} PostcardForm
   */
  init() {
    if (window.location.search) {
      this._fillFromUrl()._updateData();
    }

    $(this.el)
      .on('keyup change', `.${PostcardForm.CssClass.INPUT_TEXT}`,
          _.debounce(_.bind(this._updateData, this), 200))
      .on('change', `.${PostcardForm.CssClass.INPUT_RADIO}, ` +
          `.${PostcardForm.CssClass.INPUT_SELECT}`,
          _.debounce(_.bind(this._updateData, this), 200))
      .on('submit', e => {
        // form submit handler here
        e.preventDefault();
        this._submitToBSD().done((data, status) => {
          // console.log(data, status);
          if (status === 'success') {
            this.el.submit();
          } else {
            // do validation here.
          }
        }).fail(() => {
          // Something went wrong writing this to the Tools. Proceed anyways.
          this.el.submit();
        });
      });

    return this;
  }

  /**
   * Triggers a `postcard.update` event, passing the form data object with the
   * event object as a `postcard` property.
   * @private
   * @return {this} PostcardForm
   */
  _updateData() {
    const data = {};
    this.$el.serializeArray().map(field => {
      data[field.name] = field.value;
    });

    this.$el.trigger({
      type: PostcardForm.Event.UPDATE,
      postcard: data
    });

    return this;
  }

  /**
   * Autofill from the form based on URL parameters.
   * @private
   * @return {this} PostcardForm
   */
  _fillFromUrl() {
    let formUpdated = false;

    this.$el.find('input[type="radio"]').each((i, el) => {
      const $el = $(el);
      if ($el.val() === Utility.getUrlParameter($el.attr('name'))) {
        $el.prop('checked', true);
        formUpdated = true;
      }
    }).end().find('input, select, textarea').not('[type="radio"]')
    .each((i, el) => {
      const $el = $(el);
      const val = Utility.getUrlParameter($el.attr('name'));
      if (val) {
        $el.val(val);
        formUpdated = true;
      }
    });

    if ('pushState' in window.history && formUpdated) {
      window.history.replaceState(null, null, '/');
    }

    return this;
  }

  /**
   * Maps the form data to BSD signup form fields and submits that data via the
   * signup api.
   * @private
   * @return {jqXHR} jQuery deferred object
   */
  _submitToBSD() {
    const formData = {};
    this.$el.serializeArray().map(field => {
      formData[field.name] = field.value;
    });

    const bsdData = {
      'email': formData.email,
      'firstname': formData.firstname,
      'city': formData.city,
      'country': formData.country,
      'custom-1649': formData['bg-image'],
      'custom-1650': formData['postcard-message-1'],
      'custom-1651': formData['postcard-message-2'],
      'custom-1652': PostcardPreview.getImageUrl('front', formData),
      'custom-1653': PostcardPreview.getImageUrl('back', formData),
      'source': formData.source,
      'subsource': formData.subsource
    };
    const formUrl =
        'https://100rc-rockefeller.cp.bsd.net/page/s/summit-postcards';

    return $.post(formUrl, bsdData);
  }
}

/**
 * CSS classes used by this component.
 * @enum {string}
 */
PostcardForm.CssClass = {
  INPUT_RADIO: 'js-postcard-radio',
  INPUT_SELECT: 'js-postcard-select',
  INPUT_TEXT: 'js-postcard-text'
};

PostcardForm.Event = {
  UPDATE: 'postcard.update'
};

export default PostcardForm;
